import { DisputeRow } from 'modules/admin/dashboard/types';
import { Card } from 'shared/components/ui/Card';
import { Badge } from 'shared/components/ui/Badge';
import { Button } from 'shared/components/ui/Button';
import { formatBRL } from 'shared/utils/format';
import { useState } from 'react';
import { useToast } from 'shared/components/ui/Toast';

interface DisputesQueueProps {
  disputes: DisputeRow[];
}

export function DisputesQueue({ disputes }: DisputesQueueProps) {
  const toast = useToast();
  const [resolvedIds, setResolvedIds] = useState<string[]>([]);
  const open = disputes.filter((dispute) => !resolvedIds.includes(dispute.id));

  function resolve(dispute: DisputeRow) {
    setResolvedIds((current) => [...current, dispute.id]);
    toast({
      title: `Disputa ${dispute.id} resolvida`,
      description: `${dispute.playerName} e ${dispute.arenaName} foram notificados do resultado.`,
    });
  }

  return (
    <Card>
      <h3 className="font-heading font-semibold text-ink">Disputas e reembolsos</h3>

      <div className="mt-3 divide-y divide-border/70">
        {open.length === 0 && <p className="py-3 text-sm text-ink-secondary">Nenhuma disputa em aberto.</p>}
        {open.map((dispute) => (
          <div key={dispute.id} className="py-3">
            <div className="flex items-center justify-between">
              <p className="text-sm font-medium text-ink">
                {dispute.id} · {dispute.arenaName}
              </p>
              <Badge tone={dispute.status === 'aberta' ? 'danger' : 'warning'}>{dispute.status}</Badge>
            </div>
            <p className="mt-1 text-sm text-ink-secondary">
              {dispute.playerName} · {dispute.reason}
            </p>
            <div className="mt-2 flex items-center justify-between">
              <span className="text-sm font-semibold text-ink">{formatBRL(dispute.amount)}</span>
              <Button variant="ghost" className="px-3 py-1 text-xs" onClick={() => resolve(dispute)}>
                Resolver
              </Button>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
